export const addAlpha = (color: string, opacity: number): string => {
	const opac = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
	return color + opac.toString(16).toUpperCase();
};
